export const minRaidSize = (
  event: Pick<wowaudit.EventReference, 'primaryDifficulty' | 'instances'>,
  gameVersion: wowaudit.PageInfo['gameVersion'],
): number => {
  if (gameVersion === 'live' && event.primaryDifficulty !== 'mythic') return 10
  if (event.primaryDifficulty === 'mythic') return 20
  return event.instances[0]?.raidSize ?? 25
}
